countItem